import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  align-items: center;
`

export const Description = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
  align-items: center;
`
